import { useEntity } from "../lib/entity";

/** The canonical entity facts, from one source, so they read identically wherever they appear. */
export const EntityBlock = ({ compact = false }) => {
  const e = useEntity();
  if (!e) return null;

  const rows = [
    ["Platform", e.legal_entity],
    ["Company registration number", e.company_number],
    ["Address", e.registered_address],
    ["Submissions and media", e.email_media],
  ].filter(([, value]) => value);

  return (
    <div data-testid="entity-block">
      <p className="max-w-3xl text-sm leading-relaxed text-zinc-400" data-testid="entity-description">
        {e.institutional_description}
      </p>
      <dl className={`mt-6 grid gap-x-10 gap-y-4 ${compact ? "sm:grid-cols-2" : "sm:grid-cols-2 lg:grid-cols-3"}`}>
        {rows.map(([label, value]) => (
          <div key={label}>
            <dt className="mono text-[0.52rem] uppercase tracking-[0.16em] text-zinc-500">{label}</dt>
            <dd className="mt-1 text-xs text-zinc-300" data-testid={`entity-${label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
              {value}
            </dd>
          </div>
        ))}
      </dl>
      {e.foreign_company_position ? (
        <p className="mt-6 max-w-3xl text-xs leading-relaxed text-zinc-400" data-testid="entity-foreign-position">
          {e.foreign_company_position}
        </p>
      ) : null}
      {e.kenya?.kenyan_company_position ? (
        <p className="mt-4 max-w-3xl text-xs leading-relaxed text-zinc-300" data-testid="entity-kenyan-company">
          {e.kenya.kenyan_company_position}
        </p>
      ) : null}
      {e.kenya?.registrations_position ? (
        <p className="mt-4 max-w-3xl text-xs leading-relaxed text-zinc-300" data-testid="entity-kenyan-registrations">
          {e.kenya.registrations_position}
        </p>
      ) : null}
      {e.not_regulated_position ? (
        <p className="mt-4 max-w-3xl text-xs leading-relaxed text-zinc-500" data-testid="entity-not-regulated">
          {e.not_regulated_position}
        </p>
      ) : null}
      {e.dispute_position ? (
        <p className="mt-4 max-w-3xl text-xs leading-relaxed text-zinc-400" data-testid="entity-dispute-position">
          {e.dispute_position}
        </p>
      ) : null}
      {e.kenya?.legal_review_position ? (
        <p className="mt-4 max-w-3xl text-xs leading-relaxed text-zinc-400" data-testid="entity-legal-review">
          {e.kenya.legal_review_position}
        </p>
      ) : null}
    </div>
  );
};
